import React from "react";
import { BatchTextProcesses } from "../components/BatchTextProcesses";

export const BatchTextProcessesPage = () => {
  return (
    <div>
      <BatchTextProcesses />
    </div>
  );
};